import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#561631',      // Bordô (cor da advogada)
                secondary: '#854858',    // Bordô mais claro (harmoniza com o principal)
                accent: '#8D6E63',       // Marrom suave complementar
                error: '#CF6679',        // Rosa suave para erros
                info: '#90A4AE',         // Cinza azulado suave
                success: '#80CBC4',      // Verde esmeralda suave
                warning: '#FFCC80',      // Âmbar suave
                background: '#F8F9FA',   // Fundo muito claro
            },
            dark: {
                primary: '#7D2442',      // Versão mais clara do bordô para dark mode
                secondary: '#9A5D6B',    // Bordô mais claro para dark mode
                accent: '#A58D82',       // Marrom suave mais claro
                error: '#CF6679',        // Rosa suave para erros
                info: '#90A4AE',         // Cinza azulado suave
                success: '#80CBC4',      // Verde esmeralda suave
                warning: '#FFCC80',      // Âmbar suave
                background: '#212121',   // Fundo escuro
            },
        },
    },
});